// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FImJy1Q8tIaTG_ {
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 3px;
  text-decoration: none;
  white-space: normal;
  cursor: pointer;
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-medium, 500);
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  border: none;
  background-color: transparent;
  box-shadow: none;
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: var(--ds-space-0, 0px);
  padding: var(--ds-space-100, 8px);
  border-radius: 8px;
  color: var(--accent-text, var(--ds-icon-subtle, #626f86));
}
.FImJy1Q8tIaTG_:hover {
  background-color: var(--accent-background-hovered, var(--ds-background-neutral-hovered, #091e4224));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.FImJy1Q8tIaTG_:active {
  background-color: var(--accent-background-pressed, var(--ds-background-neutral-pressed, #091e424f));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
@media print {
  .FImJy1Q8tIaTG_ {
    display: none;
  }
}
.ykQfSfNVGUw02V {
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 3px;
  text-decoration: none;
  white-space: normal;
  cursor: pointer;
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-medium, 500);
  border: none;
  background-color: transparent;
  box-shadow: none;
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: var(--ds-space-0, 0px);
  padding: var(--ds-space-100, 8px);
  border-radius: 8px;
  color: var(--accent-text, var(--ds-icon-subtle, #626f86));
  order: 0;
}
.ykQfSfNVGUw02V:hover {
  background-color: var(--accent-background-hovered, var(--ds-background-neutral-hovered, #091e4224));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.ykQfSfNVGUw02V:active {
  background-color: var(--accent-background-pressed, var(--ds-background-neutral-pressed, #091e424f));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
@media print {
  .ykQfSfNVGUw02V {
    display: none;
  }
}
:hover > .ykQfSfNVGUw02V,
:active > .ykQfSfNVGUw02V {
  background-color: transparent;
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapseListButton": `FImJy1Q8tIaTG_`,
	"expandListButton": `ykQfSfNVGUw02V`
};
export default ___CSS_LOADER_EXPORT___;
